import { ESocialType } from '../../types/social';
export var getIgnoreSocialDataForRegistration = function getIgnoreSocialDataForRegistration(socialType) {
  var FALSE_SOCIALS = [ESocialType.AppleID];
  return !FALSE_SOCIALS.includes(socialType);
};